module.exports = __webpack_public_path__ + "static/media/leiste_excelente_1.83eeab26.png";